export default function () {
    return {
        CERTIFICATION: {
            RADIO: 'RADIO',
            FREE_TEXT: 'FREE_TEXT',
            FREE_TEXT_PREDEFINED: 'FREE_TEXT_PREDEFINED',
            CHECKBOX: 'CHECKBOX'
        },
        CERTIFICATION_FEEDBACK: {
            RADIO: 'RADIO',
            FREE_TEXT: 'FREE_TEXT'
        },
        FORM_360_FEEDBACK: {
            SCALE: 'SCALE',
            FREE_TEXT: 'FREE_TEXT'
        },
        SURVEY: {
            RADIO: 'RADIO',
            FREE_TEXT: 'FREE_TEXT',
            CHECKBOX: 'CHECKBOX',
            SCALE: 'SCALE',
            MATRIX: 'MATRIX'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/question/type/index.js